module.exports = __webpack_public_path__ + "img/about_plan.4c5e9da5.svg";